module.exports = __webpack_public_path__ + "static/assets/d3e3ad82daf219e08aae233ec9fef7cf.png";